<div class="user-rights-title" style="background-color: #ededed;">
    <span class="order-text">{{'common.mycompany_set_right'|cxTranslate}}</span>

    <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-light-grey.svg" alt=""  width="25" />
    </button>
</div>

<mat-dialog-content class="vor-order-dialog">
    <div class="user-rights">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                <ng-container *ngIf="_data.customer?.showCorePrice || _data.customer?.showListPrice || _data.customer?.showNetPrice || _data.customer?.coWorkerOrders">{{'common.text_account_gereral_rights'|cxTranslate}}</ng-container></div>
                <div class="form-check" *ngIf="_data.customer?.showCorePrice">
                    <input class="form-check-input" [(ngModel)]="dataObj.coreCharge" [checked]="dataObj.coreCharge" [value]="dataObj.coreCharge" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_core_label'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check"  *ngIf="_data.customer?.showListPrice">
                    <input class="form-check-input" [(ngModel)]="dataObj.listPrice" [checked]="dataObj.listPrice" [value]="dataObj.listPrice" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_list_label'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check" *ngIf="_data.customer?.showNetPrice">
                    <input class="form-check-input" [(ngModel)]="dataObj.netPrice" [checked]="dataObj.netPrice" [value]="dataObj.netPrice" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_net_label'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check" *ngIf="_data.customer?.coWorkerOrders">
                    <input class="form-check-input" [(ngModel)]="dataObj.coWorkerInfo" [checked]="dataObj.coWorkerInfo"  [value]="dataObj.coWorkerInfo" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_coworker_label'|cxTranslate}}
                    </label>
                </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                {{'common.text_user_viewpricesandatp_label'|cxTranslate}}</div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.priceAvail" [checked]="dataObj.priceAvail==true" [id]="" type="radio" [value]="true" [id]="'test0'" name="priceAvail" >
                    <label class="form-check-label ">
                      {{'common.text_storefront_true_value'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.priceAvail" [checked]="dataObj.priceAvail==false" [id]="" type="radio" [value]="false" [id]="'test1'" name="priceAvail">
                    <label class="form-check-label ">
                      {{'common.text_storefront_false_value'|cxTranslate}}
                    </label>
                </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                <ng-container *ngIf="_data.customer?.priceDownloadAccess || _data.customer?.customerDocDownloadAccess || _data.customer?.updateMyPart">{{'common.mycompany_accessAdditionalRights'|cxTranslate}}</ng-container></div>
                <div class="form-check" *ngIf="_data.customer?.priceDownloadAccess">
                    <input class="form-check-input" [(ngModel)]="dataObj.downloadPriceFile" [checked]="dataObj.downloadPriceFile"  [value]="dataObj.downloadPriceFile" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_priceDownloadAccess_label'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check" *ngIf="_data.customer?.customerDocDownloadAccess">
                    <input class="form-check-input" [(ngModel)]="dataObj.downloadCustomerDocs" [checked]="dataObj.downloadCustomerDocs" [value]="dataObj.downloadCustomerDocs" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_customerDocDownloadAccess_label'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check" *ngIf="_data.customer?.updateMyPart">
                    <input class="form-check-input" [(ngModel)]="dataObj.downLoadOwnPartNumber" [checked]="dataObj.downLoadOwnPartNumber" [value]="dataObj.downLoadOwnPartNumber" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_updateMyPart_label'|cxTranslate}}
                    </label>
                </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                {{'common.text_warranty_rights_label'|cxTranslate}}</div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.warrantySearch" [checked]="dataObj.warrantySearch" [value]="dataObj.warrantySearch" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                      {{'common.type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.warrantyClaim" [checked]="dataObj.warrantyClaim" [value]="dataObj.warrantyClaim" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                      {{'common.type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_name'|cxTranslate}}
                    </label>
                </div>
                 <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.warrantyClaimValue" [checked]="dataObj.warrantyClaimValue" [value]="dataObj.warrantyClaimValue" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                      {{'common.type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_VALUES_name'|cxTranslate}}
                    </label>
                </div>

        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                {{'common.text_core_rights_label'|cxTranslate}}</div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.coreSubmission" [checked]="dataObj.coreSubmission"  [value]="dataObj.coreSubmission" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.type_B2BCustomerCoreRightsEnum_CORE_SUBMISSION_name'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.coreReports" [checked]="dataObj.coreReports"  [value]="dataObj.coreReports" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.text_account_coreReports'|cxTranslate}}
                    </label>
                </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                {{'common.text_user_onlineOrdering_label'|cxTranslate}}</div>
                <div class="form-check">
                    <input class="form-check-input" [id]="" [(ngModel)]="dataObj.onlineOrdering" [checked]="dataObj.onlineOrdering==true" type="radio" [value]="true" [id]="'test0'" name="onlineOrdering" >
                    <label class="form-check-label ">
                      {{'common.text_storefront_true_value'|cxTranslate}}
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" [id]="" [(ngModel)]="dataObj.onlineOrdering" [checked]="dataObj.onlineOrdering==false" type="radio" [value]="false" [id]="'test1'" name="onlineOrdering">
                    <label class="form-check-label ">
                        {{'common.text_storefront_false_value'|cxTranslate}}
                    </label>
                </div>
        </div>
      </div>


      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">

        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">

        </div>

      </div>

      <div class="row">

        <div class="col-xs-12 col-sm-12 col-md-4 popup-general-rights-outer">
            <div class="set-user-rights-header-secondary">
                {{'common.register_checkbox_admin_label'|cxTranslate}}</div>
                <div class="form-check">
                    <input class="form-check-input" [(ngModel)]="dataObj.customerAdmin" [checked]="dataObj.customerAdmin"  [value]="dataObj.customerAdmin" type="checkbox">
                    <label class="form-check-label" for="core-charge">
                        {{'common.register_checkbox_admin'|cxTranslate}}
                    </label>
                </div>
        </div>
      </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
    <div class="d-flex action-btn">

        <a class="btn  btn-block blue-btn reset-btn" (click)="resetRight()">
            {{'common.text_account_reset'|cxTranslate}}</a>

        <button class="btn save-btn" (click)="saveUserRight()">
            {{'common.text_user_table_save'|cxTranslate}}<img src="/icons/link-dark-grey.svg" alt="Link Icon">
        </button>
    </div>
</mat-dialog-actions>
